<template>
    <AnimationWrapper :delay-animation="animationDelay">
        <template #animationContent>
            <div v-if="supportsThumbnailLayout" class="thumbnail-layout-preview" :style="cornerRadiusContainerStyle">
                <ThumbnailImagePreview
                    :thumbnail-data="columnMedia.thumbnailData"
                    :layouts="thumbnailLayouts"
                    :thumbnail-size="'section'"
                    :project="$store.state.project"
                    :interactive="false"
                    :show-helper-text-override="false"
                />
            </div>
            <div v-else-if="showSingleMockup" class="single-mockup-preview" :style="cornerRadiusContainerStyle">
                <MockupContainer :media="columnMedia" />
            </div>
            <PlaceColumnMediaContent v-else :section="section" :column-media="columnMedia" :placeholder-image="placeholderImage"/>
        </template>
    </AnimationWrapper>
</template>

<script>
    import PlaceColumnMediaContent from "./PlaceColumnMediaContent.vue";
    import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
    import MockupContainer from "@/scripts/common/components/MockupContainer.vue";
    import ThumbnailImagePreview from "@/scripts/common/components/thumbnails/ThumbnailImagePreview.vue";
    import {thumbnailLayouts} from "@/scripts/common/thumbnailLayouts.js";
    import {MockupDisplayModeEnum} from "@/scripts/common/enums.js";
    import {mapGetters} from "vuex";

    export default {
        name: "ColumnImageHelper",
        components: {ThumbnailImagePreview, MockupContainer, AnimationWrapper, PlaceColumnMediaContent},
        props: ['section', 'columnMedia', 'placeholderImage', 'index', 'totalColumns'],
        data() {
            return {
                thumbnailLayouts: thumbnailLayouts
            };
        },
        computed: {
            ...mapGetters("design", ["animationSettings"]),
            activeMockupDisplayMode() {
                if (this.columnMedia?.mockupDisplayMode === MockupDisplayModeEnum.LAYOUT || this.columnMedia?.mockupDisplayMode === MockupDisplayModeEnum.DEVICE) {
                    return this.columnMedia.mockupDisplayMode;
                }
                if (this.columnMedia?.thumbnailData && !this.columnMedia?.mockupSettings) {
                    return MockupDisplayModeEnum.LAYOUT;
                }
                return MockupDisplayModeEnum.DEVICE;
            },
            supportsThumbnailLayout() {
                return !!this.columnMedia?.thumbnailData
                    && this.activeMockupDisplayMode === MockupDisplayModeEnum.LAYOUT;
            },
            showSingleMockup() {
                return !!this.columnMedia?.mockupSettings
                    && this.activeMockupDisplayMode !== MockupDisplayModeEnum.LAYOUT;
            },
            cornerRadiusContainerStyle() {
                return {
                    borderRadius: `${this.section?.cornerRadiusPx ?? 0}px`,
                    overflow: 'hidden'
                };
            },
            animationDelay() {
                if (this.index || this.index === 0) {
                    if(this.animationSettings?.animationStyle === "SCALE") {
                        return 0;
                    } else if(this.animationSettings?.animationStyle === "PAN_LEFT") {
                        return (this.totalColumns - 1 - this.index) * 0.1;
                    } else {
                        return this.index * 0.1;
                    }
                } else {
                    return 0;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
.thumbnail-layout-preview {
    width: 100%;
    height: 100%;

    :deep(.background-color-container) {
        width: 100%;
        height: 100%;
    }

    :deep(.thumbnail-preview) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    :deep(.mockups-container.small) {
        margin: auto;
    }
}

.single-mockup-preview {
    width: 100%;
    height: 100%;
}
</style>
